interface ButtonBorderedProps {
    label?: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    fullWidth?: boolean;
    disabled?: boolean;
}

export default ({ label, onClick, fullWidth, disabled }: ButtonBorderedProps) => {
    return (
        <button
            onClick={onClick}
            type="button"
            disabled={disabled}
            className={`py-2 px-4 bg-transparent border whitespace-nowrap transition ease-in duration-200 text-center text-base font-semibold focus:outline-none rounded-md
            ${fullWidth ? ' w-full' : ''} ${disabled ? ' border-gray-600 text-gray-600' : ' border-blue-600 text-blue-600'}`}
        >
            {label}
        </button>
    );
};
